<template>
  <div>
    <template v-if="documentType === 'TODO'">
      <a-result v-if="documentToken === null">
        <template #icon>
          <a-empty description="还没有人记录待办哦~" />
        </template>
        <template #extra>
          <a-button v-tc="{ name: '记录待办' }" type="primary" :loading="loading" @click="onAdd">记录待办</a-button>
        </template>
      </a-result>
      <template v-else>
        <fei-shu-document-new :token="documentToken" :options="{ height: '70vh', titleVisible: false, everyoneEdit: true }" />
      </template>
    </template>
    <template v-else-if="documentToken">
      <fei-shu-document-new :token="documentToken" :options="{ height: '70vh', titleVisible: true, everyoneEdit: false }" />
    </template>
  </div>
</template>

<script>
import { getRandomStr } from '@/utils/utils';
import { createDocument } from '@/api/business/document';

import FeiShuDocumentNew from '@/components/FeiShu/DocumentNew';

export default {
  components: {
    FeiShuDocumentNew
  },
  props: {
    documentType: {
      type: String,
      default: 'TODO'
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    sourceId: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    documentToken() {
      const token = this.dataSource.find(item => item.category === this.documentType)?.token;
      return token || null;
    }
  },
  methods: {
    getRandomStr,
    onAdd() {
      this.loading = true;
      createDocument({
        title: this.title,
        category: this.documentType,
        objectId: this.sourceId,
        objectType: 'requirement'
      })
        .then(() => {
          this.$message.success('创建成功, 可以记录待办任务了哦~');
          this.$emit('ok');
          this.loading = false;
        })
        .catch(() => {
          this.loading = true;
        });
    }
  }
};
</script>
